<style lang="less">
.search {
  width: 100%;
  height: 100%;
  form {
    display: block;
    width: 100%;
    height: 100%;
  }
  .box {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    border-radius: 30px;
    background-color: #fff;
    img {
      position: absolute;
      left: 30px;
      top: 50%;
      margin-top: -10px;
      height: 20px;
    }
    input {
      flex: 1;
      height: 100%;
      padding-left: 60px;
      border: none;
      outline: none;
      font-size: 16px;
    }
    .btn {
      width: 100px;
      height: 100%;
      position: relative;
      z-index: 10;
      background: #2284f6;
      font-size: 16px;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
  }
}
</style>
<template>
  <div class="search">
    <form @submit="submit">
      <div class="box">
        <img src="@/assets/img/sousuo.svg" alt />
        <input type="text" v-model="keyword" :placeholder="$t('join.searching')" />
        <div class="btn" @click="search">{{ $t("join.searchBtn") }}</div>
      </div>
    </form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      keyword: ""
    }
  },
  methods: {
    search() {
      this.$emit("onSearch", this.keyword);
    },

    submit(e){
      this.search();
      e.stopPropagation();
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }

}
</script>


// WEBPACK FOOTER //
// src/views/join/Search.vue